import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { BuscarPacienteDetalleContent } from './components/BuscarPacienteDetalleContent';

export default function BuscarPacienteDetalle() {
  return (
    <>
      <MainContent
        titulo='Contratos del paciente'
        component={<BuscarPacienteDetalleContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}